import React, { useState } from "react";

import {
    Modal,
    Box,
    Typography,
    Autocomplete,
    TextField,
    Chip,
    Button,
    Card,
    CardContent,
    Divider,
} from "@mui/material";

const modalStyle = {
    margin: "auto",
    mt: {
        md: 6,
        lg: 8,
        xl: 10,
    },

    width: {
        xs: "100%",
        sm: "80%",
        md: "60%",
        lg: "50%",
        xl: "40%",
    },

    minHeight: "200px",
};

const FilterModal = ({
    technicians,
    open,
    setOpen,
    filter,
    setFilter,
    setFilteredEvents,
    filterCalendarEvents,
    defaultFilterValue,
}) => {
    const [selectedTechnicians, setSelectedTechnicians] = useState(
        filter.technicians
    );
    const handleFilter = () => {
        filterCalendarEvents(selectedTechnicians);
        setOpen(false);
    };

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <Card sx={modalStyle}>
                <CardContent>
                    <Typography variant="h6">Filter By</Typography>

                    <Autocomplete
                        multiple
                        size="small"
                        limitTags={2}
                        disablePortal
                        sx={{ mt: 1.5 }}
                        value={selectedTechnicians.map((tech) => tech.techName)}
                        onChange={(ev, newValue) => {
                            setSelectedTechnicians(
                                newValue.map((techName) => {
                                    const technician = technicians.find(
                                        (tech) => tech.techName === techName
                                    );
                                    return technician;
                                })
                            );
                        }}
                        options={technicians.map(
                            (technician) => technician.techName
                        )}
                        renderTags={(value, getTagProps) => {
                            return value.map((option, index) => (
                                <Chip
                                    variant="outlined"
                                    label={option}
                                    {...getTagProps({
                                        index,
                                    })}
                                />
                            ));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Technicians"
                            />
                        )}
                    />
                </CardContent>

                <Divider />

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        p: 2,
                    }}
                >
                    {filter.technicians.length > 0 ? (
                        <Button
                            onClick={() => {
                                setFilteredEvents(null);
                                setFilter(defaultFilterValue);
                                setSelectedTechnicians(defaultFilterValue);
                                setOpen(false);
                                filterCalendarEvents([]);
                            }}
                            sx={{ mr: 1 }}
                        >
                            Clear Filter
                        </Button>
                    ) : (
                        <Button onClick={() => setOpen(false)} sx={{ mr: 1 }}>
                            Cancel
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        type="submit"
                        onClick={handleFilter}
                    >
                        Filter Events
                    </Button>
                </Box>
            </Card>
        </Modal>
    );
};

export default FilterModal;
